export const productLinkStyles = {
  display: "flex",
  justifyContent: "start",
  color: "inherit",
  fontSize: "inherit",
  mb: 3,
  padding: "0 !important",

  svg: {
    width: 16,
    height: 16,
    transform: "translateY(-1px)",
  },
};

export const imageContainerStyles = {
  overflow: "hidden",
  bgcolor: "background.default",
  boxSizing: "border-box",
  borderRadius: "20px",
  p: 1,
  width: "auto",
  height: { xs: 241, lg: 160 },
};

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};

export const platformMapContainerStyles = {
  width: "100%",
  height: "auto",
  maxWidth: 721,
  overflow: "hidden",
  bgcolor: "background.default",
  boxSizing: "border-box",
  borderRadius: "20px",
  mb: { xs: 2, lg: 3 },
};
